module.exports = __webpack_public_path__ + "static/bandera-42e353f82a95f2fb02c41c25745c3332.png";